import React from "react"
import { BsFacebook, BsGoogle } from "react-icons/bs"
import { MdMenuBook } from "react-icons/md"
import Modal from "./index"
import styles from "../../pages/AdConversions/adConversions.module.css"

const ModalConversionGuidePicker = ({ onSelect, closeModal }) => <Modal icon={<MdMenuBook />} title="Como as conversões funcionam?" description="Escolha a plataforma para abrir a cartilha correspondente." closeModal={closeModal} fitContent={true}>
    <div className={styles.guidePicker}>
        <button type="button" onClick={() => onSelect("META")}><BsFacebook /><div><strong>Meta Ads</strong><span>API de Conversões, fonte de dados, eventos, correspondência e validação.</span></div></button>
        <button type="button" onClick={() => onSelect("GOOGLE")}><BsGoogle /><div><strong>Google Ads</strong><span>Conversões offline, GCLID, ações, atribuição e diagnóstico.</span></div></button>
    </div>
</Modal>

export default ModalConversionGuidePicker
